<template>
  <div class="main-body">

    <div class="out2">
      <div class="search2">

        <el-button size="mini" type="primary" icon="el-icon-plus" plain @click.native="toggleModalAdd">绑定设备</el-button>

        <div style="float:right">

          <el-select v-model="institutionCode"
                     @change="insChange"
                     placeholder="请选择机构" style="margin-right:5px">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-cascader
              v-model="roomCode" clearable
              placeholder="请选择房间"
              :options="ListRoom" :props="props" style="line-height:30px;margin-right: 5px;"></el-cascader>

          <el-input size="mini" placeholder="请输入设备号" v-model="imei" clearable style="margin-right:5px;width:150px"></el-input>

          <el-button size="mini" type="primary" plain icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th" border>

        <el-table-column prop="roomInfo" label="房间" width="150"></el-table-column>
        <el-table-column prop="imei" label="设备号" width="200"></el-table-column>
        <el-table-column prop="placeName" label="地点" width="100"></el-table-column>
        <el-table-column label="类型" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.deviceType==1">清雷</span>
            <span v-if="scope.row.deviceType==2">驰通达4G</span>
            <span v-if="scope.row.deviceType==3">欧万</span>
            <span v-if="scope.row.deviceType==4">一二三</span>
            <span v-if="scope.row.deviceType==5">驰通达WIFI</span>
          </template>
        </el-table-column>
        <el-table-column label="设备状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.onLine==1">在线</span>
            <span v-if="scope.row.onLine==0" style="color: red">离线</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="绑定时间" :formatter="timefilter" min-width="250"></el-table-column>

        <el-table-column fixed="right" label="操作" width="250">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="RemoveBinding(scope.row)">解绑</el-button>
            <el-button type="text" size="mini"  @click="getData(scope.$index, scope.row)" >数据</el-button>

            <el-button v-if="scope.row.deviceType==2" type="text" size="mini"  @click="setICCID(scope.row)">卡号</el-button>
            <el-button v-if="scope.row.deviceType==2" type="text" size="mini" @click="setBmdCTD(scope.row)">白名单</el-button>
            <el-button v-if="scope.row.deviceType==2" type="text" size="mini" @click="setHeightCTD(scope.row)">高度</el-button>
            <el-button v-if="scope.row.deviceType==5" type="text" size="mini" @click="setHeightCTD(scope.row)">高度</el-button>

            <el-button v-if="scope.row.deviceType==1" type="text" size="mini" @click="toggleModalSetHeightDuration(scope.row)">设置高度</el-button>
            <el-button v-if="scope.row.deviceType==4" type="text" size="mini" @click="toggleModalSetHeight(scope.row)">设置高度</el-button>

          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change"
          ></el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="showModalAdd=false"
         v-bind:arr_ins="arr_ins" v-on:getList="getList"></Add>

    <Elderly ref="myElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>

    <PushData ref="myPushData" v-show="pushDataShow" v-on:closePushData="closePushData"></PushData>


    <SetHeightDuration ref="mySetHeightDuration" v-show="showModalSetHeightDuration"
                       v-on:closeSetHeightDuration="showModalSetHeightDuration=false"
                       v-on:getList="getList"></SetHeightDuration>
    <SetHeight ref="mySetHeight" v-show="showModalSetHeight"
               v-on:closeSetHeight="showModalSetHeight=false"
               v-on:getList="getList"></SetHeight>

    <SetICCID ref="mySetICCID" v-show="iccidShow" v-on:closeMe="iccidShow=false"></SetICCID>
    <SetBmdCTD ref="mySetBmdCTD" v-show="bmdShow" v-on:closeMe="bmdShow=false"></SetBmdCTD>
    <SetHeightCTD ref="mySetHeightCTD" v-show="setHeightShowCTD"
                  v-on:closeMe="setHeightShowCTD=false"
                  v-on:getList="getList"></SetHeightCTD>


  </div>
</template>

<script>

import { timeStr,timefilters } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import {getStaffCode,} from "@/utils/auth";

import Add from "./AddInsRoom"
import Elderly from "@/views/Elderly/Comm/ElderlyInsCheckIn3";
import PushData from "../Comm/PushDataRoom";

import SetHeightDuration from "./SetHeightDuration"
import SetHeight from "./SetHeight"

import SetICCID from "../Comm/SetICCID";
import SetHeightCTD from "../Comm/SetHeightCTD"
import SetBmdCTD from "../Comm/SetBmdCTD"


export default {
  name: "Role",
  data() {
    return {
      tableLoading:false,

      showModalAdd:false,
      pushDataShow:false,
      showModalSetHeightDuration:false,
      showModalSetHeight:false,

      showModalGetElderly:false,
      showModalBigView:false,

      iccidShow:false,
      setHeightShowCTD:false,
      bmdShow:false,


      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,

      roomCode: "",
      imei: "",

      type:1,
      arr_ins:[],
      institutionCode: '',

      ListRoom:[],
      props: {
        emitPath:false,
        value: 'value',
        label: 'label',
        children: 'children'
      },

    };
  },
  components: {Add,Elderly,PushData,SetHeightDuration,
    SetHeight,SetICCID,SetHeightCTD,SetBmdCTD},
  created() {

    this.th = this.$store.state.tableHeight-70;
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val-70;
    },
  },
  methods: {

    init(){
      this.getIns();
    },

    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          type:this.type,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
            this.getBerth();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },

    toggleModalAdd: function () {
      this.$refs.myAdd.init(this.type);
      this.showModalAdd = !this.showModalAdd;
    },





    toggleModalSetHeightDuration: function (row) {
      this.$refs.mySetHeightDuration.init(row);
      this.showModalSetHeightDuration = !this.showModalSetHeightDuration;
    },
    toggleModalSetHeight: function (row) {
      this.$refs.mySetHeight.init(row);
      this.showModalSetHeight = !this.showModalSetHeight;
    },




    insChange(val){
      this.institutionCode = val;

      this.roomCode = '';
      this.ListRoom = [];

      this.getBerth();
    },
    getBerth:function (){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Berth/GovInsListAll",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.institutionCode,
        }
      }).then((response) => {
            //console.log(response);
            if (response.data.error == 0) {

              var datas=response.data.data

              var JSONData=JSON.stringify(datas);
              JSONData=JSONData.replace(/listRoomDTO/g,'children');
              //JSONData=JSONData.replace(/listBerth/g,'children');
              JSONData=JSONData.replace(/name/g,'label');
              JSONData=JSONData.replace(/number/g,'label');

              //var list=this.getListBerth(JSON.parse(JSONData),0)
              //JSONData=JSON.stringify(list);

              //JSONData=JSONData.replace(/buildingCode/g,'value');
              //JSONData=JSONData.replace(/roomCode/g,'value');
              JSONData=JSONData.replace(/roomCode/g,'value');

              //console.log(JSONData);
              this.ListRoom=JSON.parse(JSONData);

            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },



    getData(index,row){
      this.$refs.myPushData.init(row.roomCode);
      this.pushDataShow =!this.pushDataShow;
    },
    closePushData(){
      this.pushDataShow =!this.pushDataShow;
    },

    setICCID(row){
      this.$refs.mySetICCID.init(row);
      this.iccidShow =!this.iccidShow;
    },
    setHeightCTD(row){
      this.$refs.mySetHeightCTD.init(row);
      this.setHeightShowCTD =!this.setHeightShowCTD;
    },
    setBmdCTD(row){
      this.$refs.mySetBmdCTD.init(row);
      this.bmdShow =!this.bmdShow;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1
      var _this=this
      this.tableLoading=true

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceQLFall/PageByInsCodeRoom",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,

          imei: this.imei,
          roomCode:this.roomCode==null?'':this.roomCode,
          institutionCode : this.institutionCode,
        },
      }).then((response) => {
        _this.tableLoading=false
        if (response.data.error == 0) {
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        _this.tableLoading=false
        console.log(error);
      });
    },


    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    RemoveBinding(row) {
      this.$confirm("您确定要解绑该用户的设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios({
          method: "post",
          url: this.$deviceUrl + "DeviceQLFall/Delete",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            deviceQLFallCode: row.deviceQLFallCode,
          },
        }).then((response) => {

          if (response.data.error == 0) {
            this.$message({message: "解绑成功", type: "success",});
            this.getList();

          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(() => {
        this.$message({type: "info", message: "已取消解绑",});
      });

    },



  },
};
</script>

<style scoped>
</style>
